/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ApiPostDealFinanceV1ProfitabilityCalculatorCreate400,
  ErrorResponse,
  ProfitabilityCalculationRequest,
  ProfitabilityEstimateDTO
} from '../../schemas';

import { customAxios } from '../../custom-instance';
import type { ErrorType , BodyType } from '../../custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Calculate the profitability of a deal based on the input data.
 * @summary Calculate the profitability parameters of a given deal
 */
export const apiPostDealFinanceV1ProfitabilityCalculatorCreate = (
    profitabilityCalculationRequest: BodyType<ProfitabilityCalculationRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProfitabilityEstimateDTO>(
      {url: `/api/post-deal/finance/v1/profitability-calculator/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: profitabilityCalculationRequest, signal
    },
      options);
    }



export const getApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationOptions = <TError = ErrorType<ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>, TError,{data: BodyType<ProfitabilityCalculationRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>, TError,{data: BodyType<ProfitabilityCalculationRequest>}, TContext> => {

const mutationKey = ['apiPostDealFinanceV1ProfitabilityCalculatorCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>, {data: BodyType<ProfitabilityCalculationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiPostDealFinanceV1ProfitabilityCalculatorCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>>
    export type ApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationBody = BodyType<ProfitabilityCalculationRequest>
    export type ApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationError = ErrorType<ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse>

    /**
 * @summary Calculate the profitability parameters of a given deal
 */
export const useApiPostDealFinanceV1ProfitabilityCalculatorCreate = <TError = ErrorType<ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>, TError,{data: BodyType<ProfitabilityCalculationRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiPostDealFinanceV1ProfitabilityCalculatorCreate>>,
        TError,
        {data: BodyType<ProfitabilityCalculationRequest>},
        TContext
      > => {
      return useMutation(getApiPostDealFinanceV1ProfitabilityCalculatorCreateMutationOptions(options), queryClient);
    }
